module.exports = __webpack_public_path__ + "static/media/dcj-logo.e42f6043.jpg";